import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "./TitleDivSeo.css"
// import { useContext } from 'react';
// import { StatusContext } from '../ContextApiStatus';

function HaveTxtFile(props) {


    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
         <h3>الروبوتات.TXT</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          {props.CheckFoRobotsTxt ? "جيد لديك ملفات روبوتات .TXT" : "لا يوجد لديك ملفات ريبوتات.TXT "}
        </Typography>
        <Typography fontWeight="md" level="body-sm">
            <a target='_blank' href={props.UrlForRobotsTxt}>
            {props.UrlForRobotsTxt}
            </a>
        </Typography>
      </CardContent>

      { props.CheckFoRobotsTxt === true ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> :
   <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          سمح لك ملف robots.txt بتقييد وصول روبوتات محرك البحث التي تزحف إلى الويب ويمكن أن يمنع هذه الروبوتات من الوصول إلى أدلة وصفحات محددة. كما يحدد مكان وجود ملف خريطة موقع XML.
يمكنك التحقق من وجود أخطاء في ملف .txt برامج الروبوت باستخدام Google Search Console (أدوات مشرفي المواقع سابقا) من خلال تحديد "أداة اختبار الروبوتات.txt" ضمن "الزحف". ويتيح لك ذلك أيضا اختبار الصفحات الفردية للتأكد من أن Googlebot لديه حق الوصول المناسب.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default HaveTxtFile